module.exports = __webpack_public_path__ + "img/Rufael.7ebee782.png";